import React from 'react';
import Box from "@mui/material/Box";
import "./CoachingContentBox.css"
import {LoginSharp} from "@mui/icons-material";

function CoachingContentBox(props) {
    return (
        <Box className="coaching_content_box" sx={{boxShadow: "2", gap: "40px"}}>
            <Box sx={{margin: "20px"}}>

                <Box sx={{width: "auto", height: "auto", marginBottom:"20px"}}>
                    {props.icon}
                </Box>
                <Box className={"flexColumnCenter"} sx={{gap: "24px"}}>
                    <Box sx={{width: "100%"}}>
                        <p className={"heading_font"}>
                            {props.header}
                        </p>
                    </Box>

                    {props.subtitle.map((item, index) => (
                        <Box key={index} sx={{width: "100%"}}>
                            <p className={"content_font"}>{item}</p>
                        </Box>
                    ))}
                </Box>
            </Box>

        </Box>
    );
}

export default CoachingContentBox;